/**
 * Where the pose assets live — the two paths, and nothing else (S6-8).
 *
 * Split out of `pose-assets.ts` so that the paths can be read by things which must not drag the
 * engine's DOM-typed surface in with them: the end-to-end console allowlist has to know the
 * canonical model URL in order to tell *our* model request from somebody else's, and it is compiled
 * for Node. Deliberately import-free — a file that names two strings should not decide what else
 * has to typecheck to read them, and one definition is the whole point of the exercise.
 *
 * `pose-assets.ts` re-exports both, so every existing reader is unchanged.
 */

/**
 * Directory the Vite `mediapipe-wasm` plugin serves `vision_wasm*_internal.{js,wasm}` from, in
 * dev and in the built output alike. Copied from `node_modules/@mediapipe/tasks-vision/wasm`, so
 * the pinned package version is the single source of truth for the runtime.
 */
export const POSE_WASM_BASE_PATH = '/vendor/mediapipe/tasks-vision';

/**
 * The self-hosted PoseLandmarker bundle, served from `public/`.
 *
 * `full` rather than `lite` or `heavy`: `heavy` (29.2 MB) exceeds Cloudflare Pages' 25 MB
 * per-file limit outright, and `lite` loses exactly the landmarks this game leans on — see the
 * Slice 0 report for the measured comparison.
 */
export const POSE_MODEL_PATH = '/models/pose/pose_landmarker_full.task';
